<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Choferes</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Choferes</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button type="button" class="float-right" mdbBtn color="info" data-target="#basicExample"
        (click)="agregar(); showModalAgregar()" mdbWavesEffect size="sm">
        Agregar
      </button>
    </div>
    <div class="row filtros-body">
      <div class="col" style="max-width: 300px">
        <div class="md-form">
          <div class="md-form">
            <input value="" type="text" id="nomb" class="form-control" placeholder="Nombre" required
              [(ngModel)]="nombreBusquedaCG" #nomb />
            <label for="nomb">Nombre</label>
          </div>
        </div>
      </div>
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="1" mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
    <!-- Cabecera de botones -->
    <div class="card mb-2 wow">
      <!--Card content-->
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Rut</th>
                <th scope="col">Nombre</th>
                <th scope="col">Fono 1</th>
                <th scope="col">Fono 2</th>
                <th scope="col">Estado</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cho of choferesList">
                <td>{{ cho.rutFormato | rut}}</td>
                <td>{{ cho.nombre }}</td>
                <td>{{ cho.fono1 }}</td>
                <td>{{ cho.fono2 }}</td>
                <td>
                  <div *ngIf="cho.estado">
                    <mdb-badge pill="true" success="true">Activo</mdb-badge>
                  </div>
                  <div *ngIf="!cho.estado">
                    <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
                  </div>
                </td>
                <td>
                  <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                    data-toggle="modal" data-target="#basicExamplex" (click)="showModalModificar(); showForEdit(cho)"
                    mdbTooltip="Ver" placement="right">
                    <mdb-icon fas icon="pen"></mdb-icon>
                  </button>
                  <button *ngIf="!cho.estado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                    (click)="permitirCambioEstado(cho)" mdbTooltip="Activar" placement="right">
                    <mdb-icon fas icon="ban"></mdb-icon>
                  </button>
                  <button *ngIf="cho.estado" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
                    (click)="permitirCambioEstado(cho)" mdbTooltip="Desactivar" placement="right">
                    <mdb-icon fas icon="check"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div mdbModal #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form [formGroup]="formAgregarChofer_Sucursal">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Agregar Chofer
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLarge.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de chofer
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>
                    Inactivo
                    <input type="checkbox" color="info" formControlName="estado" />
                    <span class="lever"></span> Activo
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input placeholder="Ingrese RUT sin puntos" class="form-control" type="text" formatorut id="rut"
                    formatRut formControlName="rut" value="" maxLength="10" #rut tabindex="0" />
                  <label for="rut">RUT <span class="text-danger">(*)</span></label>
                  <div *ngIf="frmAgregaRut.invalid && (frmAgregaRut.dirty || frmAgregaRut.touched)">
                    <mdb-error *ngIf="frmAgregaRut.errors.ValidaFormatoRut">El RUT es erróneo</mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Nombre" class="form-control" type="text" id="nombre" formControlName="nombre"
                    value="" maxLength="100" />
                  <label for="nombre">Nombre <span class="text-danger">(*)</span></label>
                  <div *ngIf="
                    frmAgregaNombre.invalid &&
                    (frmAgregaNombre.dirty || frmAgregaNombre.touched)
                  ">
                    <mdb-error *ngIf="frmAgregaNombre.errors.required">
                      El nombre es requerido
                    </mdb-error>
                    <mdb-error *ngIf="frmAgregaNombre.errors.maxLength">
                      El nombre no puede superar los 100 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Fono1" class="form-control" type="text" id="fono1" formControlName="fono1"
                    value="" maxlength="30" />
                  <label for="fono1">Fono1</label>
                  <div *ngIf="
                    frmAgregaFono1.invalid &&
                    (frmAgregaFono1.dirty || frmAgregaFono1.touched)
                  ">
                    <mdb-error *ngIf="frmAgregaFono1.errors.maxLength">
                      El fono no puede superar los 30 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Fono2" class="form-control" type="text" id="fono2" formControlName="fono2"
                    value="" maxLength="30" />
                  <label for="fono2">Fono2</label>
                  <div *ngIf="
                    frmAgregaFono2.invalid &&
                    (frmAgregaFono2.dirty || frmAgregaFono2.touched)
                  ">
                    <mdb-error *ngIf="frmAgregaFono2.errors.maxLength">
                      El nombre no puede superar los 30 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <mdb-checkbox formControlName="es_cliente">Es Cliente</mdb-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLarge.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <app-api-button (click2)="ValidaQueExisteDatosChofer()" [processing]="processingAgregar" color="success">
            Guardar
          </app-api-button>
        </div>
      </form>
    </div>
  </div>
</div>

<div mdbModal #centralLargex="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form [formGroup]="formEditarChofer_Sucursal">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Modificar Chofer
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLargex.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de chofer
                </h5>
              </div>
              <div class="col">
                <div class="switch info-switch">
                  <label>
                    Inactivo
                    <input type="checkbox" color="info" formControlName="estado" />
                    <span class="lever"></span> Activo
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input placeholder="RUT" class="form-control" type="text" id="rutx" formControlName="rut" formatRut
                    maxLength="10" />
                  <label for="rutx">RUT <span class="text-danger">(*)</span></label>
                </div>
                <div class="md-form">
                  <input placeholder="Nombre" class="form-control" type="text" id="nombrex" formControlName="nombre"
                    maxLength="100" />
                  <label for="nombrex">Nombre <span class="text-danger">(*)</span></label>
                  <div *ngIf="frmEditaNombre.invalid && (frmEditaNombre.dirty || frmEditaNombre.touched)">
                    <mdb-error *ngIf="frmEditaNombre.errors.required">El nombre es requerido</mdb-error>
                    <mdb-error *ngIf="frmEditaNombre.errors.maxLength">El nombre no puede superar los 100
                      caracteres</mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Fono1" class="form-control" type="text" id="fono1" formControlName="fono1"
                    maxLength="30" />
                  <label for="chofonox1">Fono1</label>
                  <div *ngIf="
                    frmEditaFono1.invalid &&
                    (frmEditaFono1.dirty || frmEditaFono1.touched)
                  ">
                    <mdb-error *ngIf="frmEditaFono1.errors.maxLength">
                      El fono no puede superar los 30 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <input placeholder="Fono2" class="form-control" type="text" id="fono2" formControlName="fono2"
                    maxLength="30" />
                  <label for="fono2">Fono2</label>
                  <div *ngIf="
                    frmEditaFono2.invalid &&
                    (frmEditaFono2.dirty || frmEditaFono2.touched)
                  ">
                    <mdb-error *ngIf="frmEditaFono2.errors.maxLength">
                      El fono no puede superar los 30 caracteres
                    </mdb-error>
                  </div>
                </div>
                <div class="md-form">
                  <mdb-checkbox formControlName="es_cliente">Es Cliente</mdb-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLargex.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <app-api-button (click2)="actualizar()" [processing]="processingEditar" color="success">
            Guardar
          </app-api-button>
        </div>
      </form>
    </div>
  </div>
</div>
